import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { Dialog } from "primereact/dialog";
import { TabPanel, TabView } from "primereact/tabview";
import { formatDate } from "../../config/Config";
import { Image } from "primereact/image";
import { useContext } from "react";

import CandidateAgent from "./CandidateAgent";
import CandidateDocuments from "./CandidateDocuments";
import CandidateInfo from "./CandidateInfo";
import { CandidateDBContext } from "./CandidateDBContext";
import CandidateUsers from "./CandidateUsers";

export default function ({}) {
	var { selectedCanditate, setSelectedCanditate } = useContext(CandidateDBContext);

	return (
		<>
			<Dialog
			// maximized
				draggable={false}
				header={<small><span>{`Candidate Details - ${selectedCanditate?.eventName} `}</span></small>}
				style={{ width: "90%", height: "90%" }}
				modal
				visible={selectedCanditate!==null}
				onShow={() => {
					// execMembersHandler();
					// membersHandler();
					// execMemberRoleAvail();
					// documentsHandler();
				}}
				onHide={(e) => {
					setSelectedCanditate(null);
				}}
			>
				<TabView>
					<TabPanel header="Candidate Details">
						<CandidateInfo />
					</TabPanel>
					
					{selectedCanditate?.candidateTypeID === 1 && (
						<TabPanel header="Agents">
						<CandidateAgent />
						</TabPanel>
					)}
				
					<TabPanel header={"Documents"}>
						<CandidateDocuments />
					</TabPanel>
					<TabPanel header={"Portal Users"}>
						<CandidateUsers/>
					</TabPanel>
					{/* <TabPanel
                    header={"Registered Electors"}
                >
                    <PoliticalRegisteredElectors />
                </TabPanel> */}
				</TabView>
			</Dialog>
		</>
	);
}
